<template>
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_333_3298)">
      <path d="M2.25 22.25V23.75C2.25 24.2 2.55 24.5 3 24.5H21C21.45 24.5 21.75 24.2 21.75 23.75V22.25H2.25Z"
            fill="#437AE1"/>
      <path d="M16.5 1.7V5.75H20.55L16.5 1.7Z" fill="#437AE1"/>
      <path
          d="M8.175 14.375H7.875V15.35H8.1C8.25 15.35 8.4 15.275 8.55 15.2C8.7 15.125 8.7 14.975 8.7 14.825C8.7 14.525 8.55 14.375 8.175 14.375Z"
          fill="#437AE1"/>
      <path
          d="M12 14.375H11.7V16.775H11.925C12.3 16.775 12.525 16.7 12.675 16.475C12.825 16.25 12.9 15.95 12.9 15.575C12.9 15.2 12.825 14.9 12.675 14.675C12.525 14.45 12.375 14.375 12 14.375Z"
          fill="#437AE1"/>
      <path
          d="M23.25 10.25H21.75V7.25H15.75C15.3 7.25 15 6.95 15 6.5V0.5H3C2.55 0.5 2.25 0.8 2.25 1.25V10.25H0.75C0.3 10.25 0 10.55 0 11V20C0 20.45 0.3 20.75 0.75 20.75H23.25C23.7 20.75 24 20.45 24 20V11C24 10.55 23.7 10.25 23.25 10.25ZM9.45 15.95C9.15 16.175 8.775 16.325 8.25 16.325H7.95V17.75H6.75V13.475H8.25C8.775 13.475 9.225 13.625 9.45 13.85C9.675 14.075 9.825 14.45 9.825 14.825C9.825 15.275 9.75 15.65 9.45 15.95ZM13.575 17.15C13.2 17.525 12.6 17.75 11.925 17.75H10.575V13.475H12.075C12.75 13.475 13.275 13.625 13.65 14C14.025 14.375 14.175 14.825 14.175 15.5C14.175 16.25 13.95 16.775 13.575 17.15ZM17.475 14.375H16.05V15.2H17.325V16.1H16.05V17.75H14.925V13.475H17.475V14.375Z"
          fill="#437AE1"/>
    </g>
    <defs>
      <clipPath id="clip0_333_3298">
        <rect width="24" height="24" fill="white" transform="translate(0 0.5)"/>
      </clipPath>
    </defs>
  </svg>
</template>
<script>
export default {
  name: 'PdfIcon'
}
</script>
<style scoped>

a {
  cursor: pointer;
}

</style>